// extracted by mini-css-extract-plugin
export default {"icon":"PlusIcon_icon__FVajJ","path":"PlusIcon_path__bUBZZ"};